// Version : 1.0.0
// Author : AGALYA

import PhotoVerificationActionType from './photo-verification.types';

/** ***************** Member Photo Add Start ************************/
export const addMemberPhotoStart = (photoVerificationCredentials: any) => ({
	type: PhotoVerificationActionType.ADD_MEMBER_PHOTO_START,
	payload: photoVerificationCredentials,
});

export const addMemberPhotoSuccess = (photoVerificationSuccess: any) => ({
	type: PhotoVerificationActionType.ADD_MEMBER_PHOTO_SUCCESS,
	payload: photoVerificationSuccess,
});

export const addMemberPhotoFailure = (photoVerificationFailure: any) => ({
	type: PhotoVerificationActionType.ADD_MEMBER_PHOTO_FAILURE,
	payload: photoVerificationFailure,
});

export const addMemberPhotoResponseResetStart = () => ({
	type: PhotoVerificationActionType.ADD_MEMBER_PHOTO_RESPONSE_REST_START,
});

export const addMemberPhotoUserResponseChanged = () => ({
	type: PhotoVerificationActionType.ADD_MEMBER_PHOTO_RESPONSE_CHANGED,
});
/** ***************** Member Photo Add End ************************/
